
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ProductStockService } from "@/services/product-stock-service";
import { ProductStock } from "@/models/base";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { printHumanFloat } from "@/utils/pretty-print";

interface ILocationRow {
	id:number;
	name:string;
	qty:string;
}

export default Vue.extend({
	data(){
		return {
			loading: false,
			stock: null as ProductStock | null,
			loadedForStockId: 0
		};
	},
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		locationConfig():StockLocationConfig {
			return DossierConfigService.getStockLocationConfig();
		},
		locations():ILocationRow[] {
			if (!this.stock) return [];
			let result:ILocationRow[] = [];
			for (let id = 1; id <= StockLocationConfig.MAX_ID; id++) {
				if (id > 1 && this.locationConfig.getLocationAlias(id).match(/^\s*$/)) {
					continue;
				}
				result.push({
					id,
					name: this.locationConfig.getLocationName(id),
					qty: printHumanFloat((this.stock as any)[`Location${id}Qty`] || 0, 2)
				});
			}
			return result;
		},
		total():string {
			if (!this.stock) return "";
			let total = 0;
			for (let id = 1; id <= StockLocationConfig.MAX_ID; id++) {
				total += (this.stock as any)[`Location${id}Qty`] || 0;
			}
			return printHumanFloat(total, 2);
		},
		summary():string {
			if (!this.stock) return "";
			return `${this.$ct("sidebar.product-stock.total")} ${this.total}`;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item: {
			immediate: true,
			handler(){
				this.load();
				this.$emit("summary", this.summary);
			}
		}
	},
	methods: {
		async load(){
			if (this.item.Stock && this.item.Stock.ID) {
				this.stock = this.item.Stock;
				this.loadedForStockId = this.item.Stock.ID;
				return;
			}
			let stockId = this.item.StockID;
			if (!stockId) {
				this.stock = null;
				this.loadedForStockId = 0;
				return;
			}
			if (this.loadedForStockId == stockId) return;
			this.loadedForStockId = stockId;
			this.loading = true;
			try {
				let stock = await ProductStockService.getStocksByIds([stockId]);
				if (this.loadedForStockId != stockId) return;
				this.stock = stock && stock.ID ? stock : null;
			} catch (err) {
				this.stock = null;
			} finally {
				this.loading = false;
			}
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
